/**
 * AskAsper configuration
 * Base URL for AskAsper API - set via REACT_APP_ASK_ASPER_BASE_URL env variable
 * (configured per environment in .env / .env.dev / .env.stage / .env.prod).
 * The fallback is retained only as a safety net for local dev when the env var is missing.
 */
export const ASK_ASPER_BASE_URL =
    process.env.REACT_APP_ASK_ASPER_BASE_URL || 'https://askasper1.asper.revenuegrowth.ai/askasper/';
    // https://kind-us-pnp-dev.asper.revenuegrowth.ai/askasper/